import { Rule } from "antd/es/form";

export class RegrasComunsDeValidacaoDaAR {

    static Senha: Rule[] = [
        { required: true, message: "A senha é obrigatória" },
        { min: 8, message: "A senha deve possuir ao menos 8 caracteres" },
        { max: 1000, message: "A senha não pode ser superior a 1000 caracteres" },
        { pattern: /[A-Z]/, message: "A senha deve conter pelo menos uma letra maiúscula" },
        { pattern: /[a-z]/, message: "A senha deve conter pelo menos uma letra minúscula" },
        { pattern: /\d/, message: "A senha deve conter pelo menos um número" },
        { pattern: /[\W_]/, message: "A senha deve conter pelo menos um caractere especial" }
    ]

}